import { LinearProgress } from '@mui/material';

import { withStyles } from 'tss-react/mui';

const UpliftProgress = withStyles(LinearProgress, () => ({
  root: {
    height: '6px',
    left: 0,
    position: 'absolute',
    top: '62px',
    width: '100%',
  }
}));

export type FormProgressProps = {
  percent: number;
};

export const FormProgress: React.VFC<FormProgressProps> = ({ percent }) => (
  <UpliftProgress
    variant="determinate"
    value={percent}
  />
);
